import styled from "styled-components";

export const WrapperAuth = styled.div`
  .authenticator {
    height: 100vh;
  }
`;
